import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { createRoot } from 'react-dom/client';
import { CLIENT_SECRET, mockAccount } from '@/constants';
import FlowBuilder from '@/FlowBuilder';
import theme from '@/libs/mantine/theme';

if (import.meta.env.VITE_BUILD_MODE === 'standalone') {
	import('@mantine/core/styles.layer.css');
	import('@mantine/notifications/styles.css');
}

const root = document.getElementById('root');

if (root) {
	createRoot(root).render(
		<div style={{ width: '100vw', height: '100vh' }}>
			<MantineProvider theme={theme}>
				<ModalsProvider>
					<FlowBuilder
						account={mockAccount}
						clientSecret={CLIENT_SECRET}
					/>
				</ModalsProvider>
			</MantineProvider>
		</div>
	);
}
